<table style="width: 100%">
  <div class="container-fluid">
    <div style="float: right; margin-top: 0px; font-size: small">
      {{ this.created_on }}
    </div>
    <div class="column left" style="margin-top: -15px; margin-right: 30px">
      <img
        [src]="client_information?.logo_path_light"
        width="110px"
        height="150px"
        [alt]="client_information?.website"
      />
    </div>

    <div
      style="
        position: relative;
        align-items: left;
        justify-content: left;
        text-align: left;
      "
    >
      <div style="padding-left: 50px">
        <h2 style="padding-top: 5px">
          {{ client_information?.name?.toUpperCase() }}
        </h2>
        <p style="margin: 0; padding: 0px">
          {{ client_information?.address }}
        </p>
        <p style="margin: 0; padding: 0px">
          Tel :
          {{
            client_information?.phone_number?.dialCode +
              client_information?.phone_number?.number
          }}
        </p>
        <p style="margin: 0; padding: 0px">
          Email:
          {{ client_information?.email }}
        </p>
      </div>
      <div
        style="
          margin-top: 33px;
          justify-content: center;
          text-align: center;
          padding-right: 8px;
        "
      >
        <p style="font-size: 20px; margin-top: 2px">
          <strong>
            <ng-container *ngIf="individualInfo && !groupInfo; else defaultFormTitle"
              >HEALTH INDIVIDUAL PROPOSAL FORM</ng-container
            >
            <ng-template #defaultFormTitle>{{
              proposal_information?.proposer_details?.customer_type ===
              'INDIVIDUAL'
                ? ('policies.proposal.pdf.proposal-form-medical-ind'
                  | translate)
                : ('policies.proposal.pdf.proposal-form-medical' | translate)
            }}</ng-template>
          </strong>
          <br />
          <strong>
            <u>
              {{ 'policies.proposal.pdf.quotation-number' | translate }}-{{
                ref_number
              }}
            </u>
          </strong>
        </p>
      </div>

      <div class="content" style="padding-top: -20px; margin-top: -20px">
        <br />
        <div>
          <div>
            <!-- ============================================== -->
            <!-- LIFE & HEALTH GROUP PROPOSAL PRINT TEMPLATE    -->
            <!-- ============================================== -->
            <ng-container *ngIf="groupInfo">
              <!-- 01. Employer & Proposer Details -->
              <p class="table_caption">
                <strong>01. EMPLOYER & PROPOSER DETAILS</strong>
              </p>
              <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                <tbody>
                  <tr>
                    <th width="25%" class="table_header">Employer / Company Name</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.employer_name || proposal_information?.proposer_details?.company_name || '-' }}</td>
                    <th width="25%" class="table_header">Legal Entity</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.legal_entity || '-' }}</td>
                  </tr>
                  <tr>
                    <th width="25%" class="table_header">Business Registration No. (BRN)</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.brn || proposal_information?.proposer_details?.identification_number || '-' }}</td>
                    <th width="25%" class="table_header">Effective Date</th>
                    <td width="25%" class="table_result">{{ getFormattedDate(groupInfo?.employer_details?.effective_date || proposal_information?.proposer_details?.start_date) }}</td>
                  </tr>
                  <tr>
                    <th width="25%" class="table_header">Business Address</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.business_address || '-' }}</td>
                    <th width="25%" class="table_header">Town / City</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.town_city || '-' }}</td>
                  </tr>
                  <tr>
                    <th width="25%" class="table_header">Postal Address</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.postal_address || '-' }}</td>
                    <th width="25%" class="table_header">Postal Code</th>
                    <td width="25%" class="table_result">{{ groupInfo?.employer_details?.postal_code || '-' }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Contact Person -->
              <div *ngIf="groupInfo?.contact_person" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="4" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Contact Person Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th width="25%" class="table_header">Contact Name</th>
                      <td width="25%" class="table_result">
                        {{ [groupInfo?.contact_person?.first_name, groupInfo?.contact_person?.surname].filter(Boolean).join(' ') || '-' }}
                      </td>
                      <th width="25%" class="table_header">Designation</th>
                      <td width="25%" class="table_result">{{ groupInfo?.contact_person?.designation || '-' }}</td>
                    </tr>
                    <tr>
                      <th width="25%" class="table_header">Branch</th>
                      <td width="25%" class="table_result">{{ groupInfo?.contact_person?.branch || '-' }}</td>
                      <th width="25%" class="table_header">Gender</th>
                      <td width="25%" class="table_result">{{ groupInfo?.contact_person?.gender || '-' }}</td>
                    </tr>
                    <tr>
                      <th width="25%" class="table_header">Email</th>
                      <td width="25%" class="table_result">{{ groupInfo?.contact_person?.email || '-' }}</td>
                      <th width="25%" class="table_header">Phone</th>
                      <td width="25%" class="table_result">{{ groupInfo?.contact_person?.phone || '-' }}</td>
                    </tr>
                    <tr>
                      <th width="25%" class="table_header">Date of Birth</th>
                      <td width="25%" class="table_result">{{ getFormattedDate(groupInfo?.contact_person?.dob) }}</td>
                      <th width="25%" class="table_header">Wamhandi Member</th>
                      <td width="25%" class="table_result">{{ groupInfo?.contact_person?.wamhandi_member || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Directors Details (if any) -->
              <div *ngIf="groupInfo?.directors_details?.length" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="3" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Directors Information
                      </th>
                    </tr>
                    <tr>
                      <th width="20%" class="table_header">Salutation</th>
                      <th width="50%" class="table_header">Full Name</th>
                      <th width="30%" class="table_header">NIC / ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let director of groupInfo?.directors_details">
                      <td class="table_result">{{ director?.salutation || '-' }}</td>
                      <td class="table_result">{{ director?.full_name || '-' }}</td>
                      <td class="table_result">{{ director?.nic || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Branches (if any) -->
              <div *ngIf="groupInfo?.branches?.length" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="3" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Branches
                      </th>
                    </tr>
                    <tr>
                      <th width="35%" class="table_header">Branch Name</th>
                      <th width="30%" class="table_header">Branch Code</th>
                      <th width="35%" class="table_header">Contact Person</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let branch of groupInfo?.branches">
                      <td class="table_result">{{ branch?.branch_name || '-' }}</td>
                      <td class="table_result">{{ branch?.branch_code || '-' }}</td>
                      <td class="table_result">{{ branch?.contact_person || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Additional Information (if any) -->
              <div *ngIf="groupInfo?.additional_information?.length" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="2" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Additional Information
                      </th>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">Question / Field</th>
                      <th width="50%" class="table_header">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let info of groupInfo?.additional_information">
                      <td class="table_result">{{ info?.key || info?.name || '-' }}</td>
                      <td class="table_result">{{ info?.value || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 02. Schemes & Product Summary -->
              <p class="table_caption" style="margin-top: 20px;">
                <strong>02. PRODUCT & SCHEMES INFORMATION</strong>
              </p>
              <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                <tbody>
                  <tr>
                    <th width="25%" class="table_header">Product Nature</th>
                    <td width="25%" class="table_result">{{ titleCasePipe.transform(groupInfo?.product_summary?.nature || '-') }}</td>
                    <th width="25%" class="table_header">Coverage Basis</th>
                    <td width="25%" class="table_result">{{ titleCasePipe.transform(groupInfo?.product_summary?.coverage_basis || '-') }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Schemes Table -->
              <div *ngIf="groupInfo?.product_summary?.schemes?.length" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="6" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Schemes Summary
                      </th>
                    </tr>
                    <tr>
                      <th width="25%" class="table_header">Scheme Name</th>
                      <th width="20%" class="table_header">Product Code</th>
                      <th width="15%" class="table_header">Nature</th>
                      <th width="15%" class="table_header">Coverage Basis</th>
                      <th width="10%" class="table_header" style="text-align: center;">Members</th>
                      <th width="15%" class="table_header">Dependents</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let scheme of groupInfo?.product_summary?.schemes">
                      <td class="table_result">{{ scheme?.scheme_name || '-' }}</td>
                      <td class="table_result">{{ scheme?.product_code || '-' }}</td>
                      <td class="table_result">{{ titleCasePipe.transform(scheme?.nature || '-') }}</td>
                      <td class="table_result">{{ titleCasePipe.transform(scheme?.coverage_basis || '-') }}</td>
                      <td class="table_result" style="text-align: center;">{{ scheme?.member_count || 0 }}</td>
                      <td class="table_result">{{ getDependentsText(scheme?.dependents) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Floater Section (if any) -->
              <div *ngIf="groupInfo?.product_summary?.floater" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="4" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Floater Policy Configuration
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th width="25%" class="table_header">Product Code</th>
                      <td width="25%" class="table_result">{{ groupInfo?.product_summary?.floater?.product_code || '-' }}</td>
                      <th width="25%" class="table_header">Buffer Limit (LKR)</th>
                      <td width="25%" class="table_result">{{ formatAmount(groupInfo?.product_summary?.floater?.buffer_limit) }}</td>
                    </tr>
                  </tbody>
                </table>

                <table *ngIf="groupInfo?.product_summary?.floater?.covers?.length" width="100%" border="1" style="border-collapse: collapse; text-align: left; margin-top: 8px;">
                  <thead>
                    <tr>
                      <th width="60%" class="table_header">Floater Cover</th>
                      <th width="40%" class="table_header" style="text-align: right;">Sum Assured (LKR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cover of groupInfo?.product_summary?.floater?.covers">
                      <td class="table_result">{{ getCoverName(cover?.cover) || cover?.cover || 'Basic Cover' }}</td>
                      <td class="table_result" style="text-align: right;">{{ formatAmount(cover?.sum_assured) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 03. Members Information -->
              <p class="table_caption" style="margin-top: 20px;">
                <strong>03. MEMBERS & ENROLLMENT INFORMATION</strong>
              </p>
              <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                <tbody>
                  <tr>
                    <th width="25%" class="table_header">Total Members</th>
                    <td width="25%" class="table_result">{{ groupInfo?.members_data?.total_members || groupInfo?.member_and_dependents?.members_count || 0 }}</td>
                    <th width="25%" class="table_header">Valid Members</th>
                    <td width="25%" class="table_result">{{ groupInfo?.members_data?.valid_members || groupInfo?.member_and_dependents?.members_count || 0 }}</td>
                  </tr>
                  <tr *ngIf="groupInfo?.members_data?.file_name">
                    <th width="25%" class="table_header">Uploaded Template</th>
                    <td colspan="3" class="table_result">{{ groupInfo?.members_data?.file_name }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Members Table -->
              <div *ngIf="(groupInfo?.members_data?.members || groupInfo?.member_and_dependents?.members_list)?.length" style="margin-top: 15px;">
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th colspan="8" class="table_header" style="background-color: #e5e7eb; font-weight: bold;">
                        Enrolled Members List
                      </th>
                    </tr>
                    <tr>
                      <th width="5%" class="table_header" style="text-align: center;">#</th>
                      <th width="15%" class="table_header">Scheme</th>
                      <th width="15%" class="table_header">Member ID</th>
                      <th width="22%" class="table_header">Full Name</th>
                      <th width="10%" class="table_header">Gender</th>
                      <th width="12%" class="table_header">DOB</th>
                      <th width="11%" class="table_header">NIC</th>
                      <th width="10%" class="table_header">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let member of (groupInfo?.members_data?.members || groupInfo?.member_and_dependents?.members_list); let idx = index">
                      <td class="table_result" style="text-align: center;">{{ idx + 1 }}</td>
                      <td class="table_result">{{ member?.scheme_name || '-' }}</td>
                      <td class="table_result">{{ member?.member_id || '-' }}</td>
                      <td class="table_result">{{ [member?.salutation, member?.first_name, member?.last_name].filter(Boolean).join(' ') || '-' }}</td>
                      <td class="table_result">{{ member?.gender || '-' }}</td>
                      <td class="table_result">{{ member?.dob || '-' }}</td>
                      <td class="table_result">{{ member?.nic || '-' }}</td>
                      <td class="table_result">{{ member?.status || 'Valid' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 04. Billing & Payments -->
              <p class="table_caption" style="margin-top: 20px;">
                <strong>04. BILLING & PAYMENT INFORMATION</strong>
              </p>
              <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                <tbody>
                  <tr>
                    <th width="25%" class="table_header">Billing Frequency</th>
                    <td width="25%" class="table_result">{{ titleCasePipe.transform(groupInfo?.billing_and_payments?.billing_frequency || groupInfo?.billing_and_payments?.frequency || 'Annual') }}</td>
                    <th width="25%" class="table_header">Payment Method</th>
                    <td width="25%" class="table_result">{{ titleCasePipe.transform(groupInfo?.billing_and_payments?.payment_method || 'Cheque') }}</td>
                  </tr>
                  <tr *ngIf="groupInfo?.billing_and_payments?.net_premium || groupInfo?.billing_and_payments?.total_premium">
                    <th width="25%" class="table_header">Net Premium (LKR)</th>
                    <td width="25%" class="table_result">{{ formatAmount(groupInfo?.billing_and_payments?.net_premium) }}</td>
                    <th width="25%" class="table_header">Total Payable (LKR)</th>
                    <td width="25%" class="table_result"><strong>{{ formatAmount(groupInfo?.billing_and_payments?.total_premium) }}</strong></td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <!-- ============================================== -->
            <!-- LIFE & HEALTH INDIVIDUAL PROPOSAL PRINT        -->
            <!-- ============================================== -->
            <ng-container *ngIf="individualInfo && !groupInfo">
              <!-- 01. Proposer Details -->
              <p class="table_caption"><strong>01. PROPOSER DETAILS</strong></p>
              <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                <tbody>
                  <tr>
                    <th width="25%" class="table_header">Name</th>
                    <td width="25%" class="table_result">{{ getName(proposal_information?.proposer_details?.name) || '-' }}</td>
                    <th width="25%" class="table_header">NIC Number</th>
                    <td width="25%" class="table_result">{{ proposal_information?.proposer_details?.identification_number || proposal_information?.proposer_details?.nic || '-' }}</td>
                  </tr>
                  <tr>
                    <th width="25%" class="table_header">Date of Birth (Age)</th>
                    <td width="25%" class="table_result">
                      {{ getFormattedDate(proposal_information?.proposer_details?.date_of_birth) }}
                      <span *ngIf="proposal_information?.proposer_details?.age"> ({{ proposal_information?.proposer_details?.age }})</span>
                    </td>
                    <th width="25%" class="table_header">Email</th>
                    <td width="25%" class="table_result">{{ getEmail(proposal_information?.proposer_details?.email) || '-' }}</td>
                  </tr>
                  <tr>
                    <th width="25%" class="table_header">Contact Number</th>
                    <td width="25%" class="table_result">{{ getPhone(proposal_information?.proposer_details?.contact) || '-' }}</td>
                    <th width="25%" class="table_header">Policy Period</th>
                    <td width="25%" class="table_result">
                      {{ getFormattedDate(proposal_information?.proposer_details?.start_date) }} -
                      {{ getFormattedDate(proposal_information?.proposer_details?.end_date) }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- 02. Proposer Additional Information -->
              <div *ngIf="lhSummary?.additional_information?.length" style="margin-top: 20px">
                <p class="table_caption"><strong>02. PROPOSER ADDITIONAL INFORMATION</strong></p>
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <tbody>
                    <tr *ngFor="let info of lhSummary.additional_information">
                      <th width="50%" class="table_header">{{ info.label }}</th>
                      <td width="50%" class="table_result">{{ info.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 03. Product Information -->
              <div *ngIf="lhSummary" style="margin-top: 20px">
                <p class="table_caption"><strong>03. PRODUCT INFORMATION</strong></p>
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <tbody>
                    <tr>
                      <th width="25%" class="table_header">Product</th>
                      <td width="25%" class="table_result">{{ lhSummary.product_name }} ({{ lhSummary.product_code }})</td>
                      <th width="25%" class="table_header">Nature</th>
                      <td width="25%" class="table_result">{{ lhSummary.nature }}</td>
                    </tr>
                  </tbody>
                </table>
                <table *ngIf="lhSummary.coverage_rows?.length" width="100%" border="1" style="border-collapse: collapse; text-align: left; margin-top: 10px">
                  <thead>
                    <tr>
                      <th width="70%" class="table_header">Coverage</th>
                      <th width="30%" class="table_header">Member Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of lhSummary.coverage_rows">
                      <td class="table_result">{{ row.label }}</td>
                      <td class="table_result">{{ row.count }}</td>
                    </tr>
                  </tbody>
                </table>
                <ng-container *ngFor="let block of [
                  { title: 'Covers & Sum Assured Details', covers: lhSummary.covers },
                  { title: 'Floater Basis Cover', covers: lhSummary.floater_covers }
                ]">
                  <table *ngIf="block.covers?.length" width="100%" border="1" style="border-collapse: collapse; text-align: left; margin-top: 10px">
                    <thead>
                      <tr>
                        <th colspan="2" class="table_header" style="background-color: #e5e7eb; font-weight: bold">{{ block.title }}</th>
                      </tr>
                      <tr>
                        <th width="70%" class="table_header">Cover</th>
                        <th width="30%" class="table_header">Sum Assured ({{ lhSummary.currency }})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let cov of block.covers">
                        <tr>
                          <td class="table_result">{{ cov.name }}</td>
                          <td class="table_result">{{ cov.sum_assured }}</td>
                        </tr>
                        <tr *ngFor="let sub of cov.sublimits">
                          <td class="table_result" style="padding-left: 24px">&mdash; {{ sub.name }}</td>
                          <td class="table_result">{{ sub.value }}</td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </ng-container>
              </div>

              <!-- 04. Dependents Information -->
              <div *ngIf="individualInfo?.dependents_information?.groups?.length" style="margin-top: 20px">
                <p class="table_caption"><strong>04. DEPENDENTS INFORMATION</strong></p>
                <ng-container *ngFor="let group of individualInfo.dependents_information.groups">
                  <table *ngIf="group?.members?.length" width="100%" border="1" style="border-collapse: collapse; text-align: left; margin-bottom: 10px">
                    <thead>
                      <tr>
                        <th colspan="6" class="table_header" style="background-color: #e5e7eb; font-weight: bold">
                          {{ lhSummary?.dependent_labels?.[group.type] || getDependentLabel(group.type) }}
                        </th>
                      </tr>
                      <tr>
                        <th class="table_header">Full Name</th>
                        <th class="table_header">NIC</th>
                        <th class="table_header">Date of Birth (Age)</th>
                        <th class="table_header">Gender</th>
                        <th class="table_header">Relation</th>
                        <th class="table_header">Weight / Height</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let m of group.members">
                        <td class="table_result">{{ getMemberName(m) }}</td>
                        <td class="table_result">{{ m?.nic || '-' }}</td>
                        <td class="table_result">{{ getFormattedDate(m?.date_of_birth) }}<span *ngIf="m?.age !== '' && m?.age !== null && m?.age !== undefined"> ({{ m.age }})</span></td>
                        <td class="table_result">{{ m?.gender || '-' }}</td>
                        <td class="table_result">{{ m?.relation || '-' }}</td>
                        <td class="table_result">{{ m?.weight ? m.weight + ' KG' : '-' }} / {{ m?.height ? m.height + ' CM' : '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </div>

              <!-- 05. Medical History -->
              <div *ngIf="individualInfo?.medical_history" style="margin-top: 20px">
                <p class="table_caption"><strong>05. MEDICAL HISTORY</strong></p>
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <thead>
                    <tr>
                      <th width="80%" class="table_header">Question</th>
                      <th width="20%" class="table_header" style="text-align: center">Answer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let q of individualInfo?.medical_history?.questions || []; let qi = index">
                      <tr>
                        <td class="table_result">Q{{ qi + 1 }}. {{ q?.question || '-' }}</td>
                        <td class="table_result" style="text-align: center"><strong>{{ q?.answer === 'YES' ? 'Yes' : 'No' }}</strong></td>
                      </tr>
                      <ng-container *ngIf="q?.answer === 'YES'">
                        <tr *ngFor="let ap of q?.affected_persons || []">
                          <td colspan="2" class="table_result" style="padding-left: 24px">
                            Patient: {{ ap?.patient || '-' }} | Doctor: {{ ap?.doctor || '-' }} |
                            Treatment Details: {{ ap?.condition_details || '-' }} |
                            Last Date of Treatment: {{ getFormattedDate(ap?.last_treatment_date) }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
                <table *ngIf="individualInfo?.medical_history?.chronic_medication?.length" width="100%" border="1" style="border-collapse: collapse; text-align: left; margin-top: 10px">
                  <thead>
                    <tr>
                      <th colspan="3" class="table_header" style="background-color: #e5e7eb; font-weight: bold">Current Chronic Medication</th>
                    </tr>
                    <tr>
                      <th class="table_header">Patient</th>
                      <th class="table_header">Medicine</th>
                      <th class="table_header">Last Date of Treatment</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let cm of individualInfo.medical_history.chronic_medication">
                      <tr *ngFor="let med of cm?.medicines || []">
                        <td class="table_result">{{ cm?.patient || '-' }}</td>
                        <td class="table_result">{{ med?.medicine || '-' }}</td>
                        <td class="table_result">{{ getFormattedDate(med?.from) }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
                <p *ngIf="individualInfo?.medical_history?.other_condition" class="table_result" style="margin-top: 8px">
                  Any Other Condition: {{ individualInfo.medical_history.other_condition }}
                </p>
              </div>

              <!-- 06. Payment Method -->
              <div *ngIf="individualInfo?.payment_method" style="margin-top: 20px">
                <p class="table_caption"><strong>06. PAYMENT METHOD</strong></p>
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <tbody>
                    <tr>
                      <th width="25%" class="table_header">Preferred Payment Method</th>
                      <td width="25%" class="table_result">{{ individualInfo?.payment_method?.preferred_method || '-' }}</td>
                      <th width="25%" class="table_header">Total Annual Premium</th>
                      <td width="25%" class="table_result">{{ formatAmount(individualInfo?.payment_method?.total_annual_premium) }}</td>
                    </tr>
                    <tr *ngIf="individualInfo?.payment_method?.credit_amount">
                      <th width="25%" class="table_header">Requested Credit Amount</th>
                      <td width="25%" class="table_result">{{ formatAmount(individualInfo?.payment_method?.credit_amount) }}</td>
                      <th width="25%" class="table_header">Credit Period</th>
                      <td width="25%" class="table_result">{{ individualInfo?.payment_method?.credit_period ? individualInfo.payment_method.credit_period + ' Days' : '-' }}</td>
                    </tr>
                    <tr *ngFor="let sch of individualInfo?.payment_method?.schedules || []; let si = index">
                      <th width="25%" class="table_header">Schedule {{ si + 1 }}</th>
                      <td width="25%" class="table_result">{{ getFormattedDate(sch?.collection_date) }} ({{ sch?.days || 0 }} Days)</td>
                      <th width="25%" class="table_header">Amount</th>
                      <td width="25%" class="table_result">{{ formatAmount(sch?.amount) }}</td>
                    </tr>
                    <tr *ngIf="individualInfo?.payment_method?.bank_details?.bank">
                      <th width="25%" class="table_header">Bank / Branch</th>
                      <td width="25%" class="table_result">{{ individualInfo?.payment_method?.bank_details?.bank_name || '-' }} / {{ individualInfo?.payment_method?.bank_details?.branch_name || '-' }}</td>
                      <th width="25%" class="table_header">Account Holder / Number</th>
                      <td width="25%" class="table_result">{{ individualInfo?.payment_method?.bank_details?.account_holder_name || '-' }} / {{ individualInfo?.payment_method?.bank_details?.account_number || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 07. Supporting Documents -->
              <div *ngIf="individualInfo?.supporting_documents?.length" style="margin-top: 20px">
                <p class="table_caption"><strong>07. SUPPORTING DOCUMENTS</strong></p>
                <table width="100%" border="1" style="border-collapse: collapse; text-align: left">
                  <tbody>
                    <tr *ngFor="let doc of individualInfo.supporting_documents">
                      <th width="60%" class="table_header">{{ doc?.name || doc?.document_type || 'Document' }}</th>
                      <td width="40%" class="table_result">{{ doc?.file_name || doc?.original_name || (doc?.file ? 'Uploaded' : '-') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Declaration / signature -->
              <div style="margin-top: 40px">
                <table width="100%" style="border-collapse: collapse; text-align: left">
                  <tr>
                    <td width="50%" class="table_result">.....................................................<br />Signature of the Proposer</td>
                    <td width="50%" class="table_result">.....................................................<br />Date</td>
                  </tr>
                </table>
              </div>
            </ng-container>

            <!------ Legacy Medical Steppers Fallback -------->
            <ng-container *ngIf="!groupInfo && !individualInfo">
              <p class="table_caption">
                <strong>
                  01.
                  {{ 'policies.proposal.add-edit.steppers.1' | translate }}
                </strong>
              </p>

              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <tr>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.type-pdf'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        proposal_information?.proposer_details?.customer_type ||
                          '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.name'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        getName(proposal_information?.proposer_details?.name)
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.engagement-pdf'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        titleCasePipe.transform(
                          proposal_information?.proposer_details?.engagement
                        )
                      }}
                    </td>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.contact'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                      proposal_information?.proposer_details?.contact?.[0]
                      ? getPhone(
                      proposal_information?.proposer_details?.contact
                      )
                      : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.email'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                      proposal_information?.proposer_details?.email?.[0]
                      ? getEmail(
                      proposal_information?.proposer_details?.email
                      )
                      : '-'
                      }}
                    </td>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.fax'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details?.fax
                          ? getPhone(
                              proposal_information?.proposer_details?.fax
                            )
                          : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.identification_number'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details
                          ?.identification_number || '-'
                      }}
                    </td>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.occupation'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details?.occupation ||
                          '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.vat_number'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details?.vat_number ||
                          '-'
                      }}
                    </td>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.svat_number'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details?.svat_number ||
                          '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.communication-mode-pdf'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{ communication_modes }}
                    </td>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.communication-language-pdf'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{ communication_languages }}
                    </td>
                  </tr>
                  <tr>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.start-date'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details?.start_date
                          ? dateTimeFormatService.formatDateWithoutTime(
                              proposal_information?.proposer_details?.start_date
                            )
                          : ''
                      }}
                    </td>
                    <th class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.proposer.end-date'
                          | translate
                      }}
                    </th>
                    <td class="table_result">
                      {{
                        proposal_information?.proposer_details?.end_date
                          ? dateTimeFormatService.formatDateWithoutTime(
                              proposal_information?.proposer_details?.end_date
                            )
                          : '-'
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <!-- Medical Group Sections -->
            <!-- Scheme And Sum Assured Info -->
            <ng-container *ngIf="isMedicalGroup">
              <p class="table_caption">
                <strong> 02. SCHEME INFORMATION </strong>
              </p>

              <ng-container
                *ngFor="
                  let scheme of proposal_information
                    ?.medical_group_scheme_products?.productMedicalGroupScheme;
                  let i = index
                "
              >
                <table
                  width="100%"
                  border="1"
                  style="border-collapse: collapse; text-align: left"
                >
                  <tbody>
                    <tr>
                      <th width="50%" class="table_header">Scheme</th>
                      <td width="50%" class="table_result">
                        {{ scheme?.scheme || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">Scheme Count</th>
                      <td width="50%" class="table_result">
                        {{ scheme?.count || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">Product Code</th>
                      <td width="50%" class="table_result">
                        {{ scheme?.product_code || '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />

                <ng-container
                  *ngFor="let breakup of scheme?.scheme_breakups; let j = index"
                >
                  <table
                    width="100%"
                    border="1"
                    style="border-collapse: collapse; text-align: left"
                  >
                    <tbody>
                      <tr>
                        <th width="50%" class="table_header">
                          Scheme Breakup (Coverage)
                        </th>
                        <td width="50%" class="table_result">
                          {{ getCoverageName(breakup?.breakup) || '-' }}
                        </td>
                      </tr>
                      <tr>
                        <th width="50%" class="table_header">Member Count</th>
                        <td width="50%" class="table_result">
                          {{ breakup?.member_count || '-' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />

                  <ng-container
                    *ngFor="let cover of breakup?.covers_list; let k = index"
                  >
                    <table
                      width="100%"
                      border="1"
                      style="border-collapse: collapse; text-align: left"
                    >
                      <tbody>
                        <tr>
                          <th width="50%" class="table_header">Cover</th>
                          <td width="50%" class="table_result">
                            {{ getCoverName(cover?.cover) || '-' }}
                          </td>
                        </tr>
                        <tr>
                          <th width="50%" class="table_header">
                            Sum Assured (LKR)
                          </th>
                          <td width="50%" class="table_result">
                            {{ cover?.sum_assured || '-' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <br />
                </ng-container>
              </ng-container>

              <!-- Floater -->

              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <tr>
                    <th width="50%" class="table_header">Scheme</th>
                    <td width="50%" class="table_result">Floater</td>
                  </tr>
                  <tr>
                    <th width="50%" class="table_header">Product Code</th>
                    <td width="50%" class="table_result">
                      {{ floaterData?.product_code || '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />

              <ng-container
                *ngFor="let cover of floaterData?.covers_list; let k = index"
              >
                <table
                  width="100%"
                  border="1"
                  style="border-collapse: collapse; text-align: left"
                >
                  <tbody>
                    <tr>
                      <th width="50%" class="table_header">Cover</th>
                      <td width="50%" class="table_result">
                        {{ getCoverName(cover?.cover) || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">
                        Sum Assured (LKR)
                      </th>
                      <td width="50%" class="table_result">
                        {{ cover?.sum_assured || '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
              <br />
            </ng-container>

            <!-- Members Info Info -->
            <!-- <ng-container *ngIf="isMedicalGroup">
              <p class="table_caption">
                <strong> 02. Members Information </strong>
              </p>

              <ng-container
                *ngFor="
                  let member of proposal_information?.medical_group_members_information;
                  let i = index
                "
              >
                <table
                  width="100%"
                  border="1"
                  style="border-collapse: collapse; text-align: left"
                >
                  <tbody>
                    <tr>
                      <th width="50%" class="table_header">Name</th>
                      <td width="50%" class="table_result">
                        {{ member?.name || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">NIC</th>
                      <td width="50%" class="table_result">
                        {{ member?.nic || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">Mobile Number</th>
                      <td width="50%" class="table_result">
                        {{ member?.mobile_number || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">Date of Birth</th>
                      <td width="50%" class="table_result">
                        {{ getFormattedDate(member?.date_of_birth) || '-' }}
                      </td>
                    </tr>
                    <tr>
                      <th width="50%" class="table_header">Employee Number</th>
                      <td width="50%" class="table_result">
                        {{ member?.employee_number || '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </ng-container>
              <br />
            </ng-container> -->

            <!-- Insured Section -->
            <ng-container *ngIf="!isMedicalGroup">
              <p class="table_caption">
                <strong>
                  02.
                  {{
                    'policies.proposal.add-edit.steppers.2-medical' | translate
                  }}
                </strong>
              </p>
              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_1'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_1
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_1'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_1
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_2'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_2
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_3'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_3
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_4'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_4
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_5'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_5
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_6'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_6
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_7'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_7
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_8'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_8
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_9'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_9
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_10'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_10
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_11'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_11
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_12'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_12
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_13'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.question_13
                            ?.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_14'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details
                            ?.alcohol_consumption?.value
                        )
                      }}
                    </td>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.type'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        proposal_information?.insured_details
                          ?.alcohol_consumption?.type
                          ? proposal_information?.insured_details
                              ?.alcohol_consumption?.type
                          : '-'
                      }}
                    </td>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.weekly-consumption'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        proposal_information?.insured_details
                          ?.alcohol_consumption?.amount
                          ? proposal_information?.insured_details
                              ?.alcohol_consumption?.amount +
                            ' ' +
                            proposal_information?.insured_details
                              ?.alcohol_consumption?.rate
                          : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_15'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details
                            ?.smoke_consumption?.value
                        )
                      }}
                    </td>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.type'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        proposal_information?.insured_details?.smoke_consumption
                          ?.type
                          ? proposal_information?.insured_details
                              ?.smoke_consumption?.type
                          : '-'
                      }}
                    </td>
                    <th colspan="2" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.daily-consumption'
                          | translate
                      }}
                    </th>
                    <td colspan="2" class="table_result">
                      {{
                        proposal_information?.insured_details?.smoke_consumption
                          ?.amount
                          ? proposal_information?.insured_details
                              ?.smoke_consumption?.amount +
                            ' ' +
                            proposal_information?.insured_details
                              ?.smoke_consumption?.rate
                          : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_17'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details?.has_good_health
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.insured-person.question_18'
                          | translate
                      }}
                    </th>
                    <td colspan="4" class="table_result">
                      {{
                        getStringForBoolean(
                          proposal_information?.insured_details
                            ?.pregnant_details?.value
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <!-- Member Section -->
            <ng-container
              *ngIf="
                !isMedicalGroup &&
                (proposal_information?.member_details?.length || 0) > 0
              "
            >
              <p class="table_caption">
                <strong>
                  03.
                  {{
                    'policies.proposal.add-edit.steppers.3-medical' | translate
                  }}
                </strong>
              </p>

              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <ng-container
                    *ngFor="let member of proposal_information?.member_details"
                  >
                    <tr>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.details-of-insured.name'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ member?.name }}
                      </td>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.details-of-insured.relationship'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ member?.relationship }}
                      </td>
                    </tr>
                    <tr>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.details-of-insured.dob'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{
                          dateTimeFormatService.formatDateWithoutTime(
                            member?.dob
                          )
                        }}
                      </td>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.details-of-insured.occupation'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ member?.occupation ? member?.occupation : '-' }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </ng-container>

            <!------ Additional Covers Stepper -------->
            <ng-container *ngIf="!isMedicalGroup">
              <p class="table_caption">
                <strong>
                  {{ coverSectionNumber }}
                  {{ 'policies.proposal.add-edit.steppers.7' | translate }}
                </strong>
              </p>

              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <tr>
                    <th width="50%" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.additional-covers.hd1'
                          | translate
                      }}
                    </th>
                    <th
                      width="50%"
                      class="table_header"
                      style="text-align: right"
                    >
                      {{
                        'policies.proposal.add-edit.steppers.additional-covers.hd2'
                          | translate
                      }}
                    </th>
                  </tr>
                  <tr
                    *ngFor="
                      let cover of this.proposal_information
                        ?.additional_covers_details?.covers
                    "
                  >
                    <td width="50%" class="table_result">
                      {{ cover?.name }}
                    </td>
                    <td
                      width="50%"
                      class="table_result"
                      style="text-align: right"
                    >
                      {{ thousandSeparatorAdd(cover?.value) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <!-- Claim Section -->
            <!-- <ng-container>
              <p class="table_caption">
                <strong>
                  {{ isMedicalGroup ? '02.' : '05.' }}
                  {{
                    'policies.proposal.add-edit.steppers.4-medical' | translate
                  }}
                </strong>
              </p>

              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <ng-container
                    *ngFor="let claim of proposal_information?.claim_details"
                  >
                    <tr>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.previous-claims.period'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ claim?.period }}
                      </td>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.previous-claims.total-claims'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ claim?.totalClaims }}
                      </td>
                    </tr>
                    <tr>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.previous-claims.opd-value'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ claim?.opdValue }}
                      </td>
                      <th class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.previous-claims.indoor-value'
                            | translate
                        }}
                      </th>
                      <td class="table_result">
                        {{ claim?.indoorValue ? claim?.indoorValue : '-' }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </ng-container> -->

            <!------ Credit Request Stepper -------->
            <ng-container>
              <p class="table_caption">
                <strong>
                  {{ creditSectionNumber }}
                  {{ 'policies.proposal.add-edit.steppers.2' | translate }}
                </strong>
              </p>

              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <tr>
                    <th width="25%" class="table_header">Payment Method</th>
                    <td width="25%" class="table_result">
                      {{
                        titleCasePipe.transform(
                          proposal_information?.credit_request_details
                            ?.payment_method
                        ) || '-'
                      }}
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      proposal_information?.credit_request_details
                        ?.payment_method === 'CREDIT'
                    "
                  >
                    <th width="25%" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.credit-request.credit-amount'
                          | translate
                      }}
                    </th>
                    <td width="25%" class="table_result">
                      {{
                        proposal_information?.credit_request_details
                          ?.credit_amount || '-'
                      }}
                      Days
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      proposal_information?.credit_request_details
                        ?.payment_method === 'CREDIT'
                    "
                  >
                    <th width="25%" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.credit-request.credit-period'
                          | translate
                      }}
                    </th>
                    <td width="25%" class="table_result">
                      {{
                        proposal_information?.credit_request_details
                          ?.credit_period || '-'
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                *ngIf="
                  proposal_information?.credit_request_details?.schedules
                    ?.length > 0 &&
                  proposal_information?.credit_request_details
                    ?.payment_method === 'CREDIT'
                "
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
              >
                <tbody>
                  <ng-container
                    *ngFor="
                      let sch of proposal_information?.credit_request_details
                        ?.schedules
                    "
                  >
                    <tr>
                      <td width="33.3%" class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.credit-request.date'
                            | translate
                        }}
                      </td>
                      <td width="33.3%" class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.credit-request.days'
                            | translate
                        }}
                      </td>
                      <td width="33.3%" class="table_header">
                        {{
                          'policies.proposal.add-edit.steppers.credit-request.amount'
                            | translate
                        }}
                      </td>
                    </tr>

                    <tr>
                      <td width="33.3%" class="table_result">
                        {{
                          sch?.date
                            ? dateTimeFormatService.formatDateWithoutTime(
                                sch?.date
                              )
                            : '-'
                        }}
                      </td>
                      <td width="33.3%" class="table_result">
                        {{ sch?.number_of_days }}
                      </td>
                      <td width="33.3%" class="table_result">
                        {{ sch?.amount }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
              <table
                width="100%"
                border="1"
                style="border-collapse: collapse; text-align: left"
                *ngIf="
                  proposal_information?.credit_request_details
                    ?.payment_method === 'CREDIT'
                "
              >
                <tbody>
                  <tr>
                    <th width="50%" class="table_header">
                      {{
                        'policies.proposal.add-edit.steppers.credit-request.remark'
                          | translate
                      }}
                    </th>
                    <td width="50%" class="table_result">
                      {{
                        proposal_information?.credit_request_details?.remark ||
                          '-'
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
        </div>
      </div>

      <p class="table_caption">
        <strong> {{ 'policies.proposal.pdf.declaration' | translate }}</strong>
      </p>
      <div style="margin: auto; text-align: justify">
        {{ 'policies.proposal.pdf.declaration-medical' | translate }}
      </div>

      <table
        width="100%"
        border="1"
        style="border-collapse: collapse; text-align: left; margin-top: 20px"
      >
        <tbody>
          <tr>
            <th width="50%" class="table_header">
              {{ 'policies.proposal.pdf.name-office' | translate }}
            </th>
            <td width="50%" class="table_result"></td>
          </tr>
          <tr>
            <th width="50%" class="table_header">
              {{ 'policies.proposal.pdf.date' | translate }}
            </th>
            <td width="50%" class="table_result"></td>
          </tr>
          <tr height="100px">
            <th width="50%" class="table_header">
              {{ 'policies.proposal.pdf.sign-with-stamp' | translate }}
            </th>
            <td width="50%" class="table_result"></td>
          </tr>
        </tbody>
      </table>

      <div
        class="footer"
        style="justify-content: center; text-align: center; margin-left: -10px"
      ></div>
    </div>
  </div>
</table>
